/**
 * Menu API Service
 * Handles API calls for menu endpoints
 */

import { injectable } from "inversify";
import { apiService } from "@/remote/api";
import { config } from "@/config";
import type { MenuListResponseDto, MenuItemDto } from "../response/MenuResponse";

/**
 * Mock menu data for development
 */
const mockMenuData: readonly MenuItemDto[] = [
  {
    menuId: "dashboard",
    title: "Dashboard",
    icon: "LayoutGrid",
    routePath: "/swarapoint/dashboard",
    sortOrder: 10,
  },
  {
    menuId: "reward-catalog",
    title: "Reward Catalog",
    icon: "Gift",
    routePath: "/swarapoint/reward-catalog",
    sortOrder: 20,
  },
  {
    menuId: "tiering-settings",
    title: "Tiering Settings",
    icon: "Layers",
    routePath: "/swarapoint/tiering-settings",
    sortOrder: 30,
  },
  {
    menuId: "programs",
    title: "Programs",
    icon: "Calendar",
    routePath: "/swarapoint/programs",
    sortOrder: 40,
  },
  {
    menuId: "customer-data",
    title: "Customer Data",
    icon: "Users",
    routePath: "/swarapoint/customer-data",
    sortOrder: 50,
  },
  {
    menuId: "points-settings",
    title: "Points Settings",
    icon: "Settings",
    routePath: "/swarapoint/points-settings",
    sortOrder: 60,
  },
  {
    menuId: "merchant-approval",
    title: "Merchant Approval",
    icon: "CheckCircle",
    routePath: "/swarapoint/merchant-approval",
    sortOrder: 70,
  },
];

@injectable()
export class MenuApiService {
  private readonly useMockData: boolean;

  constructor() {
    this.useMockData = config.features.useMockData;
  }

  /**
   * Fetch all menu items
   * Endpoint: GET /product/api/v1/menus
   */
  async fetchMenus(): Promise<readonly MenuItemDto[]> {
    if (this.useMockData) {
      return new Promise((resolve) => {
        setTimeout(() => resolve(mockMenuData), 300);
      });
    }

    const response = await apiService.getRaw<MenuListResponseDto>(
      "/product/api/v1/menus",
    );

    return response.data;
  }
}

